<template>
    <div
        class="l-ss-c-results-info"
        :class="{
            'l-ss-c-results-info-with-message': hasAutocompleteElements || !totalItemsCount,
            'l-ss-c-results-info-only-results': totalItemsCount && !hasAutocompleteElements && !hasTips,
            'l-ss-c-results-info-with-tips': hasTips,
            'l-ss-c-results-info-with-autocomplete': hasAutocompleteElements,
        }">
        <div
            class="l-ss-c-results-info-header"
            v-if="message && hasAutocompleteElements">
            <span
                v-if="message"
                class="l-ss-c-results-info-help-text"
                v-html="message">
            </span>

            <span
                class="l-ss-c-results-info-autocomplete-items"
                v-if="hasAutocompleteElements && !isStandardSearchType">
                <span
                    v-for="item in list"
                    :key="item"
                    class="l-ss-c-results-info-autocomplete-item"
                    @click="() => handleSearch(item)">{{ item }}
                </span>
            </span>
        </div>

        <section-results-info-tips
            v-if="hasTips"
            :search="search"
            @handle-tags-click="$emit('handle-tags-click', $event)"
            @result-tab-click="$emit('result-tab-click', $event)"/>

        <div
            class="l-ss-c-results-info-count"
            v-if="totalItemsCount">
            {{ foundItemsMessage }}
        </div>
    </div>
</template>

<script>
    import { computed } from '@/lib/vue-composition-api.js';
    import SectionResultsInfoTips from '@/core/components/section-results/section-results-info-tips.vue';

    export default {
        components: {
            SectionResultsInfoTips,
        },
        props: {
            search: {
                type: Object,
            },
            totalItemsCount: {
                type: Number,
                default: 0,
            },
        },
        setup(props, { emit, root }) {
            const hasAutocompleteElements = computed(() => {
                return props.search
                    && props.search.suggestions
                    && !!props.search.suggestions.length;
            });

            const list = computed(() => {
                return props.search?.suggestions || [];
            });

            const hasTips = computed(() => {
                return !!props.search?.tips?.length;
            });

            const isStandardSearchType = computed(() => {
                const searchType = props.search?.meta?.searchType;
                const excludedKeywords = ['narrow', 'chat-gpt' , 'image'];
                return searchType && !searchType.some(type => excludedKeywords.some(keyword => type.includes(keyword)));
            });

            const message = computed(() => {
                if (hasAutocompleteElements.value && isStandardSearchType.value) {
                    return root.$t('autocomplete.similar', { 0: props.search.query });
                } else if (isStandardSearchType.value) {
                    return root.$t('searchType.similarSearchResultsMessage');
                } else if (!props.totalItemsCount) {
                    return root.$t('noResultsFoundMessage', { 0: props.search.query });
                }

                return '';
            });

            const foundItemsMessage = computed(() => {
                return `${root.$t('results.foundResults')}: ${props.totalItemsCount}`;
            });

            const handleSearch = (value) => {
                emit('autocomplete-search', value);
            };

            return {
                hasAutocompleteElements,
                list,
                hasTips,
                message,
                foundItemsMessage,
                handleSearch,
                isStandardSearchType,
            };
        },
    };
</script>

<style scoped>

</style>
